import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { IDCardContext } from '../Context/IDCardContext';

const IDCard = () => {
  const context = useContext(IDCardContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getIDCards();
    };
    getData();
  }, [search]);

  const getIDCards = async () => {
    setLoading(true);
    await get(
      `/id-card${search}`,
      (res) => {
        context.IDCards = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);
    await destroy(
      `/id-card/${id}`,
      (res) => {
        success(`ای دی کارت "${modalRemoveObject?.title}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getIDCards();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست آی دی کارت ها'
          createBtnTitle='ایجاد آی دی کارت'
          createPath='/id-card/create'
        />
        <Datatable
          data={context.IDCards?.data}
          editUrl='/id-card/edit'
          meta={context.IDCards?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/id-card`}
          columns={['عنوان', 'مسابقه']}
          rows={[
            { name: 'title', type: 'string' },
            { name: 'competition.title', type: 'relation', relType: 'string' },
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف ای دی کارت "${modalRemoveObject?.title}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default IDCard;
